import { configureStore } from '@reduxjs/toolkit'
import { backendApi } from './backendApi'

/**
 * Redux store — vain RTK Query -API-kutsuille (K6). Sovelluksen muu tila
 * (virkailijat, rooli, tukipyyntöjen/käyttäjien mutaatiot) on edelleen
 * Context-storessa (src/state/store.tsx). Redux hoitaa pelkän backend-fetchin.
 */
export const reduxStore = configureStore({
  reducer: {
    [backendApi.reducerPath]: backendApi.reducer,
  },
  middleware: getDefault => getDefault().concat(backendApi.middleware),
})
